import React from 'react';
import Navbar from '../components/Navbar';
import SmallClaimsIPFSBlockchainTest from '../tests/SmallClaimsIPFSBlockchainTest';

/**
 * TestPage Component
 * 
 * This page provides access to the comprehensive E2E test for the Civil Claims system.
 * It demonstrates the complete workflow of the application from data collection to blockchain registration.
 */
function TestPage() {
  return (
    <>
      <Navbar />
      <div className="container mx-auto px-4 py-8 mt-20">
        <h1 className="text-3xl font-bold text-center mb-6">Civil Claims Integration Testing</h1>
        <p className="text-center text-gray-600 mb-8">
          This page provides a testing environment for the end-to-end Civil Claims process,
          including IPFS storage (raw and encrypted) and blockchain registration.
        </p>
        
        <div className="test-container bg-white p-6 rounded-lg shadow-md">
          <SmallClaimsIPFSBlockchainTest />
        </div>
      </div>
    </>
  );
}

export default TestPage;